import {
  AlignLeftOutlined,
  CheckSquareOutlined,
  ColumnHeightOutlined,
  FontSizeOutlined,
  OrderedListOutlined,
  StarOutlined,
} from '@ant-design/icons'
import { FormItemTypes } from '@models/FormItem'

export const getIconByTypeId = (id: number) => {
  switch (id) {
    case FormItemTypes.Title:
      return <FontSizeOutlined />
    case FormItemTypes.Input:
      return <AlignLeftOutlined />
    case FormItemTypes.TextArea:
      return <FontSizeOutlined />
    case FormItemTypes.CheckboxGroup:
      return <OrderedListOutlined />
    case FormItemTypes.Select:
      return <CheckSquareOutlined />
    case FormItemTypes.Rate:
      return <StarOutlined />
    case FormItemTypes.Spacer:
      return <ColumnHeightOutlined />
    default:
      break
  }
}
